<template>
    <div @click="open()">
        <v-text-field
            ref="input"
            :value="selectedDateDescription"
            append-icon="event"
            single-line
            hide-details
            outline
            readonly>
        </v-text-field>
        <v-dialog
            v-if="editMode"
            :value="true"
            persistent
            @keydown.esc="cancel()"
            width="290px">
            <v-date-picker scrollable
                :value="editValue"
                :allowed-dates="allowedDates"
                @input="updateValue">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="cancel()">Cancel</v-btn>
                <v-btn text color="primary" @click="submit()">OK</v-btn>
            </v-date-picker>
        </v-dialog>
    </div>
</template>

<script>
import ForecastingUtilService from '@/services/forecastingUtilService';

import { mapState } from 'vuex';
import momentCache from "@/services/momentCache";

export default {
    components: {

    },
    props: {
        value: {
            type: String,
            required: true
        }
    },
    data(){
        return {
            editMode: false,
            localValue: null
        };
    },
    computed: {
        ...mapState("ForecastingStore", [
            "financialYearCalendarData",
        ]),
        editValue(){
            if(this.localValue == null){
                return momentCache.getMoment(this.value).format('YYYY-MM-DD');
            }

            return momentCache.getMoment(this.localValue).format('YYYY-MM-DD');
        },
        selectedDateDescription(){
            return `WK${ForecastingUtilService.getFinancialWeek(this.value, this.financialYearCalendarData)} FY${ForecastingUtilService.getFinancialYear(this.value, this.financialYearCalendarData)}`;
        }
    },
    methods: {
        open(){
            this.editMode = true;
        },
        updateValue(newValue){
            this.localValue = momentCache.getMoment(newValue, "YYYY-MM-DD").format('YYYY-MM-DD');
        },
        cancel(){
            this.localValue = null;
            this.editMode = false;
        },
        submit(){
            this.$emit("input", momentCache.getMoment(this.editValue, "YYYY-MM-DD").format('YYYY-MM-DD'));
            this.localValue = null;
            this.editMode = false;
        },
        allowedDates(val){
            var date = new Date(val);
            return date.getDay() == 1 && this.financialYearCalendarData.some(f => f.financialYear == date.getFullYear());
        },
    },
    created(){
        
    }
}
</script>